/**
 * Warm-tinted shadow scale.
 * Uses rgba(48,42,34,...) — linen.900 tone — instead of pure black.
 * Shadows feel organic and kitchen-warm, not cold/corporate.
 */

export const shadows = {
  xs:    '0 1px 2px rgba(48, 42, 34, 0.04)',
  sm:    '0 1px 3px rgba(48, 42, 34, 0.06), 0 1px 2px rgba(48, 42, 34, 0.04)',
  md:    '0 4px 6px rgba(48, 42, 34, 0.06), 0 2px 4px rgba(48, 42, 34, 0.04)',
  lg:    '0 10px 15px rgba(48, 42, 34, 0.06), 0 4px 6px rgba(48, 42, 34, 0.04)',
  xl:    '0 20px 25px rgba(48, 42, 34, 0.08), 0 8px 10px rgba(48, 42, 34, 0.04)',
  '2xl': '0 25px 50px rgba(48, 42, 34, 0.12)',

  // Card resting + hover
  card:       '0 2px 8px rgba(48, 42, 34, 0.06), 0 1px 3px rgba(48, 42, 34, 0.04)',
  'card-hover': '0 8px 24px rgba(48, 42, 34, 0.10), 0 4px 8px rgba(48, 42, 34, 0.05)',

  // Accent glow (for hover/focus states)
  'glow-sage':       '0 0 0 3px rgba(91, 138, 91, 0.15)',
  'glow-terracotta': '0 0 0 3px rgba(240, 128, 64, 0.15)',
  'glow-butter':     '0 0 0 3px rgba(255, 217, 102, 0.2)',

  // Focus ring
  focus: '0 0 0 3px rgba(91, 138, 91, 0.3)',

  // Inner shadow for pressed/inset states
  inner: 'inset 0 2px 4px rgba(48, 42, 34, 0.04)',
};
